import React, { useState } from 'react';
import { faFacebookF } from '@fortawesome/free-brands-svg-icons/faFacebookF';
import { faShareNodes } from '@fortawesome/pro-regular-svg-icons/faShareNodes';
import { faLink } from '@fortawesome/pro-regular-svg-icons/faLink';
import { FormattedMessage, useIntl } from 'react-intl';

import CopyLinkSnackBar from '@osmosis/nextjs-components/Snackbar/CopyLinkSnackBar';
import { Button } from '@osmosis/tailwind-ui/components/Button';
import { Icon } from '@osmosis/tailwind-ui/components/Icon';
import { shareOnFacebook } from '../../lib/frontend/share';
import { Box } from '@osmosis/tailwind-ui/components/Box';
import { text0 } from '@osmosis/tailwind-ui/styles/text';
import useModal from '../../hooks/useModal';
import PopupMenuRow from '../PopupMenuRow';
import PopupMenu from '../PopupMenu';
import Snackbar from '../Snackbar';

type Props = {
  buttonClassname?: string;
};

/**
 * Share button with dropdown options.
 */
const BasicShareButton = (props: Props) => {
  const { buttonClassname = '' } = props;

  const { isVisible, hide, toggle } = useModal();
  const intl = useIntl();

  const [showCopySnackBar, setShowCopySnackBar] = useState(false);

  const handleCopyLink = () => {
    const newUrl = new URL(window.location.href);

    if (navigator?.clipboard) {
      navigator.clipboard.writeText(newUrl.href).then(() => {
        setShowCopySnackBar(true);
        hide();
      });
    }
  };

  return (
    <Box>
      <PopupMenu
        keyExtractor={(item) => item.id}
        isVisible={isVisible}
        hide={hide}
        renderItem={(item) => (
          <PopupMenuRow dataTestid={`popup-menu-item-${item.id}`} item={item} />
        )}
        heading={intl.formatMessage({
          defaultMessage: 'Share',
          id: 'share-heading-text',
        })}
        centerHeading={true}
        items={[
          {
            id: 'copy_link',
            text: intl.formatMessage({
              defaultMessage: 'Copy link',
              id: 'share-button-copy-link',
            }),
            icon: faLink,
            onClick: handleCopyLink,
          },
          {
            id: 'facebook',
            text: 'Facebook',
            icon: faFacebookF,
            onClick: shareOnFacebook,
          },
        ]}
        containerClasses="min-w-[300px]"
      >
        <Button
          onClick={toggle}
          variant="outline"
          startIcon={<Icon icon={faShareNodes} />}
          data-testid="sharebutton-toggle"
          className={`${text0} border-1 ${buttonClassname}`}
        >
          <FormattedMessage id="sharebutton-text" defaultMessage="Share" />
        </Button>
      </PopupMenu>
      <Snackbar
        isVisible={showCopySnackBar}
        hide={() => setShowCopySnackBar(false)}
        message={<CopyLinkSnackBar />}
        variant="positive"
      />
    </Box>
  );
};

export default BasicShareButton;
